import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'small' | 'medium' | 'large';
  children: ReactNode;
  icon?: ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  size = 'medium', 
  children, 
  icon,
  className = '',
  ...props 
}: ButtonProps) {
  const baseStyles = 'whitespace-nowrap font-medium transition-all duration-200 cursor-pointer inline-flex items-center justify-center gap-2';
  
  const variants = {
    primary: 'bg-[#1A3A52] text-white hover:bg-[#2E5C8A]',
    secondary: 'bg-white text-[#1A3A52] border-2 border-[#1A3A52] hover:bg-[#E8EFF5]',
    outline: 'bg-transparent text-[#1A3A52] border border-[#1A3A52] hover:bg-[#E8EFF5]'
  };
  
  const sizes = {
    small: 'px-4 py-2 text-sm rounded-md',
    medium: 'px-6 py-3 text-base rounded-lg',
    large: 'px-8 py-4 text-lg rounded-lg'
  };
  
  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
      {icon && <span>{icon}</span>}
    </button>
  );
}